enum Type {
  BasicTrainee = 1,
  HigherTrainee = 2,
  Fellow = 3
}

enum Mode {
  FullTime = 1,
  PartTime = 2
}

enum Status {
  Active = 1,
  Completed = 2,
  Deferred = 3,
  Terminated = 4
}

enum HistoryActionType {
  Creation = 1,
  Deferral = 2,
  Termination = 3,
  Activation = 4
}

enum RecordActivityType {
  NA = 0,
  BTSEP = 1,
  HTSEP = 2,
  Activity = 3,
  Examination = 4
}

export const traineeprofileEnum = {
  Type,
  Mode,
  Status,
  HistoryActionType,
  RecordActivityType
}
